export const ROLE_ADMIN = 'ROLE_ADMIN';
export const ROLE_MARKETING = 'ROLE_MARKETING';
export const ROLE_OPHTHA = 'ROLE_OPHTHA';
export const ROLE_NURSE = 'ROLE_NURSE';
export const ROLE_ORTHOPTIST = 'ROLE_ORTHOPTIST';
export const ROLE_ANONYMIZE = 'ROLE_ANONYMIZE';
